import {NgModule} from '@angular/core';
import {StoreModule} from "@ngrx/store";
import * as fromStore from './index';
import {EffectsModule} from "@ngrx/effects";

@NgModule({
  imports: [
    StoreModule.forFeature('dbStore', fromStore.reducers),
    EffectsModule.forFeature(fromStore.effects)
  ],
  exports: [
    StoreModule,
    EffectsModule
  ]
})
export class DbStoreModule {}
